"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var object_1 = require("./object");
var handleCurry_1 = require("./utils/handleCurry");
var objectOf_1 = require("./objectOf");
var function_1 = require("./function");
var description_1 = require("./utils/description");
var typeToPredicate_1 = require("./typeToPredicate");
var isObjectOfPredicates = objectOf_1.default(function_1.default);
function isStructure(structure, value) {
    var extraArgs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        extraArgs[_i - 2] = arguments[_i];
    }
    if (!object_1.default(structure)) {
        throw new TypeError('Structure must be an object');
    }
    var keys = Object.keys(structure);
    if (keys.length === 0) {
        throw new Error('Structure object cannot be empty. No enumerable properties found');
    }
    if (!isObjectOfPredicates(structure)) {
        throw new TypeError('Structure object must consist of predicates');
    }
    keys.forEach(function (key) {
        structure[key] = typeToPredicate_1.getPredicateForType(structure[key]) || structure[key];
    });
    var structureDescription = keys
        .reduce(function (result, key) {
        result.push("\"" + key + "\" - " + description_1.getDescription(structure[key]));
        return result;
    }, [])
        .join(', ');
    return handleCurry_1.default.call(this, arguments, description_1.setDescription(function isStructurePredicate(value) {
        var _this = this;
        var match = function (key) { return structure[key].apply(_this, [value[key]].concat(extraArgs)); };
        return object_1.default(value) && keys.every(match);
    }, 'an object with properties: ' + structureDescription));
}
exports.default = isStructure;
